import React, { useState } from 'react';

import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ReactMarkdown from 'react-markdown';

const Header = ({ children }: { children?: React.ReactNode }) => (
  <Typography color="textPrimary" mb={0.5} mt={2} variant="body2Bold">
    {children}
  </Typography>
);

export const ReportTip = ({ content, title }: { content: string; title: string }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        color="secondary"
        onClick={() => setOpen(true)}
        size="small"
        startIcon={<InfoOutlinedIcon />}
        variant="text"
      >
        Tips for using this report
      </Button>
      <Dialog
        maxWidth="lg"
        onClose={() => setOpen(false)}
        open={open}
        slotProps={{
          paper: {
            sx: {
              py: 1,
            },
          },
        }}
      >
        <DialogTitle>
          <Stack alignItems="start" direction="row" justifyContent="space-between">
            Learn how to get the most out of {title} report
            <IconButton
              onClick={() => setOpen(false)}
              sx={{
                transform: 'translateY(-8px) translateX(8px)',
              }}
            >
              <CloseOutlinedIcon />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent sx={{ pt: '0 !important' }}>
          <Typography color="textSecondary" variant="body2">
            <ReactMarkdown
              components={{
                a: ({ children, href }) => (
                  <Link href={href} target="_blank">
                    {children}
                  </Link>
                ),
                h1: Header,
                h2: Header,
                h3: Header,
                h4: Header,
                h5: Header,
                h6: Header,
                p: ({ children }) => (
                  <Typography color="textSecondary" mb={0.5} variant="body2">
                    {children}
                  </Typography>
                ),
              }}
            >
              {content}
            </ReactMarkdown>
          </Typography>
        </DialogContent>
      </Dialog>
    </>
  );
};
